module.exports = __webpack_public_path__ + "static/media/16.9004cf4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/16.jpg
// module id = 946
// module chunks = 0